import angular from "angular";
import Hammer from "hammerjs";
import zoomElement from "./content_zoom.html";
export default angular
    .module("sbApp.sbContentZoom", [])
    .directive(
        "sbContentZoom",
        function ($compile, $timeout, $templateCache, $document) {
            "ngInject";

            return {
                restrict: "A",
                controllerAs: "zoom",
                bindToController: {
                    minZoom: "<", // minimum zoom value in %
                    maxZoom: "<", // maximum zoom value in %
                    step: "<", // button step
                    parentContainerId: "@", // content parent to bind ctrl key + scroll event
                    viewBox: "<",
                },
                controller: function () {
                    const zoom = this;

                    zoom.step = zoom.step || 10;
                    zoom.minZoom = zoom.minZoom || 1;
                    zoom.maxZoom = zoom.maxZoom || 5000;
                    zoom.sliderStep = 0.001;
                    // default zoom percentage is 100
                    zoom.zoom = 100;
                },
                link: function (scope, element, attr, ctrl) {
                    const MIN_FIT_ZOOM_FACTOR = 0.8;
                    const MAX_PAN_OUTSIDE_RATIO = 0.5;

                    /////////////////////
                    //
                    //      Variables
                    //
                    /////////////////////

                    const container = angular.element(element[0]);
                    const parentElement = document.getElementById(
                        ctrl.parentContainerId
                    );
                    const parentAngularElement = parentElement
                        ? angular.element(parentElement)
                        : undefined;
                    const originalParentOverflow = parentElement
                        ? parentElement.style.overflow
                        : undefined;
                    let zoomControls;
                    let pendingZoomFocus;
                    let pinchManager;
                    let pinchStartZoom;
                    let pinchFocus;

                    const panState = {
                        isDragging: false,
                        suppressClick: false,
                        hasDragged: false,
                        startClientX: 0,
                        startClientY: 0,
                        startPanOffsetX: 0,
                        startPanOffsetY: 0,
                        offsetX: 0,
                        offsetY: 0,
                    };
                    let renderedScale = 1;

                    ctrl.zoomIn = zoomIn;
                    ctrl.zoomOut = zoomOut;

                    /////////////////////
                    //
                    //      WATCHER
                    //
                    /////////////////////

                    scope.$watch("zoom.zoom", function (value, previousValue) {
                        const viewportFocus =
                            value !== previousValue
                                ? pendingZoomFocus || _captureViewportFocus()
                                : undefined;

                        pendingZoomFocus = undefined;

                        _updateZoom(value, false, viewportFocus);
                    });

                    if (parentElement) {
                        container.on(
                            "wheel mousewheel DOMMouseScroll",
                            _onScroll
                        );
                        container.on("mousedown", _onPanStart);
                        container[0].addEventListener(
                            "click",
                            _suppressClickAfterPan,
                            true
                        );
                        parentAngularElement.css("overflow", "hidden");

                        pinchManager = new Hammer.Manager(container[0], {
                            inputClass: Hammer.TouchInput,
                        });
                        pinchManager.add(new Hammer.Pinch());
                        pinchManager.on("pinchstart", function (event) {
                            pinchStartZoom = ctrl.zoom;
                            pinchFocus = _captureViewportFocus({
                                clientX: event.center.x,
                                clientY: event.center.y,
                            });
                            panState.suppressClick = true;
                        });
                        pinchManager.on("pinchmove", function (event) {
                            const viewportFocus = pinchFocus && {
                                ...pinchFocus,
                                anchorClientX: event.center.x,
                                anchorClientY: event.center.y,
                            };
                            const nextZoom = Math.max(
                                ctrl.minZoom,
                                Math.min(
                                    ctrl.maxZoom,
                                    pinchStartZoom * event.scale
                                )
                            );

                            scope.$evalAsync(function () {
                                pendingZoomFocus = viewportFocus;
                                ctrl.zoom = nextZoom;
                            });
                        });
                    }

                    angular.element($document[0]).on("mousemove", _onPanMove);
                    angular.element($document[0]).on("mouseup", _onPanEnd);
                    angular.element(window).on("resize", _onResize);

                    const svgRenderedWatcher = scope.$watch(
                        "zoom.viewBox",
                        function (viewBox) {
                            if (!viewBox || !parentElement) {
                                // svg not yet rendered
                                return;
                            }

                            _applyFitZoom(viewBox);
                            // Remove watcher
                            svgRenderedWatcher();
                        }
                    );

                    scope.$on("$destroy", function () {
                        if (pinchManager) {
                            pinchManager.destroy();
                        }
                        if (zoomControls) {
                            zoomControls.off("mousedown", _preventPanStart);
                        }
                        if (parentElement) {
                            container.off(
                                "wheel mousewheel DOMMouseScroll",
                                _onScroll
                            );
                            container.off("mousedown", _onPanStart);
                            container[0].removeEventListener(
                                "click",
                                _suppressClickAfterPan,
                                true
                            );
                            parentElement.style.overflow =
                                originalParentOverflow;
                        }
                        angular
                            .element($document[0])
                            .off("mousemove", _onPanMove);
                        angular.element($document[0]).off("mouseup", _onPanEnd);
                        angular.element(window).off("resize", _onResize);
                    });

                    _init();

                    /////////////////////
                    //
                    //      IMPL
                    //
                    /////////////////////

                    function _init() {
                        const buttons = angular.element("<div></div>");

                        buttons.addClass("sb-content-zoom");
                        buttons.html($templateCache.get(zoomElement));
                        buttons.on("mousedown", _preventPanStart);
                        zoomControls = buttons;

                        $compile(buttons)(scope);
                        // Insert buttons after the container
                        container.after(buttons);

                        _disableTextSelection();
                        container.css("transform-origin", "top left");

                        _updateZoom(ctrl.zoom, true);
                    }

                    function _disableTextSelection() {
                        container.css("user-select", "none");
                        container.css("-webkit-user-select", "none");
                        container.css("-ms-user-select", "none");
                    }

                    function _applyFitZoom(viewBox) {
                        const fitZoom = _calculateFitZoom(
                            parentElement,
                            viewBox
                        );
                        const defaultStep = Math.max(ctrl.step, 1);
                        const minFitZoom = Math.max(
                            ctrl.sliderStep,
                            fitZoom * MIN_FIT_ZOOM_FACTOR
                        );

                        if (ctrl.maxZoom <= minFitZoom) {
                            ctrl.maxZoom = minFitZoom + defaultStep * 100;
                        }

                        ctrl.minZoom = minFitZoom;
                        ctrl.zoom = minFitZoom;
                        panState.offsetX = 0;
                        panState.offsetY = 0;

                        $timeout(function () {
                            _updateZoom(ctrl.zoom, true);
                        }, 0);
                    }

                    function _calculateFitZoom(svgContainer, svgViewbox) {
                        if (
                            !svgContainer ||
                            !svgViewbox ||
                            !svgViewbox.width ||
                            !svgViewbox.height
                        ) {
                            return 100;
                        }

                        if (
                            svgContainer.clientWidth <= 0 ||
                            svgContainer.clientHeight <= 0
                        ) {
                            return 100;
                        }

                        // The SVG itself already scales to the container width. Fit zoom only
                        // needs to reduce that baseline when the resulting height overflows.
                        const baselineHeight =
                            (svgContainer.clientWidth / svgViewbox.width) *
                            svgViewbox.height;
                        const fitScale =
                            svgContainer.clientHeight / baselineHeight;

                        if (!Number.isFinite(fitScale) || fitScale <= 0) {
                            return 100;
                        }

                        return Math.min(fitScale * 100, 100);
                    }

                    /**
                     * This function handles the mouse wheel event to zoom the svg accordingly.
                     */
                    function _onScroll(event) {
                        const nativeEvent = event.originalEvent || event;
                        if (!nativeEvent) {
                            return;
                        }

                        event.preventDefault();

                        let delta = Number.parseFloat(nativeEvent.wheelDelta);
                        if (!Number.isFinite(delta)) {
                            delta = -Number.parseFloat(nativeEvent.deltaY);
                        }
                        if (!Number.isFinite(delta)) {
                            delta = -Number.parseFloat(nativeEvent.detail);
                        }

                        if (!Number.isFinite(delta) || delta === 0) {
                            return;
                        }

                        pendingZoomFocus = _captureViewportFocus({
                            clientX: nativeEvent.clientX,
                            clientY: nativeEvent.clientY,
                        });

                        $timeout(function () {
                            if (delta > 0) {
                                zoomIn();
                            } else {
                                zoomOut();
                            }
                        }, 0);
                    }

                    /**
                     * Updates css properties width and height with given value
                     */
                    function _updateZoom(
                        value,
                        centerIfPossible,
                        viewportFocus
                    ) {
                        container.css("width", "100%");
                        container.css("height", "auto");

                        if (centerIfPossible) {
                            panState.offsetX = 0;
                            panState.offsetY = 0;
                        }

                        _applyContainerTransform();

                        if (!centerIfPossible && viewportFocus) {
                            _restoreViewportFocus(viewportFocus);
                        }

                        _clampPanOffsets();
                        _applyContainerTransform();

                        _syncPanCursor();
                    }

                    function _preventPanStart(event) {
                        event.stopPropagation();
                    }

                    function _suppressClickAfterPan(event) {
                        if (!panState.suppressClick) {
                            return;
                        }

                        panState.suppressClick = false;
                        event.preventDefault();

                        if (event.stopImmediatePropagation) {
                            event.stopImmediatePropagation();
                        }

                        event.stopPropagation();
                    }

                    function _captureViewportFocus(anchorPoint) {
                        if (!parentElement) {
                            return undefined;
                        }

                        const parentRect =
                            parentElement.getBoundingClientRect();
                        const contentRect = _measureContentRect();

                        if (contentRect.width <= 0 || contentRect.height <= 0) {
                            return undefined;
                        }

                        const anchorClientX = Number.isFinite(
                            anchorPoint && anchorPoint.clientX
                        )
                            ? anchorPoint.clientX
                            : parentRect.left + parentRect.width / 2;
                        const anchorClientY = Number.isFinite(
                            anchorPoint && anchorPoint.clientY
                        )
                            ? anchorPoint.clientY
                            : parentRect.top + parentRect.height / 2;
                        const focusX = anchorClientX - contentRect.left;
                        const focusY = anchorClientY - contentRect.top;

                        return {
                            xRatio: _clampRatio(focusX / contentRect.width),
                            yRatio: _clampRatio(focusY / contentRect.height),
                            anchorClientX,
                            anchorClientY,
                        };
                    }

                    function _applyContainerTransform() {
                        if (!parentElement) {
                            return;
                        }

                        const measuredDimensions = _measureContentDimensions();
                        const centeredOffsets =
                            _calculateCenteredOffsets(measuredDimensions);
                        const scale = _getScale();

                        const translateX = centeredOffsets.x + panState.offsetX;
                        const translateY = centeredOffsets.y + panState.offsetY;

                        container.css(
                            "transform",
                            `translate(${translateX}px, ${translateY}px) scale(${scale})`
                        );
                        renderedScale = scale;
                    }

                    function _restoreViewportFocus(viewportFocus) {
                        if (!parentElement || !viewportFocus) {
                            return;
                        }

                        const parentRect =
                            parentElement.getBoundingClientRect();
                        const contentRect = _measureContentRect();
                        if (contentRect.width <= 0 || contentRect.height <= 0) {
                            return;
                        }

                        const anchorClientX = Number.isFinite(
                            viewportFocus.anchorClientX
                        )
                            ? viewportFocus.anchorClientX
                            : parentRect.left + parentRect.width / 2;
                        const anchorClientY = Number.isFinite(
                            viewportFocus.anchorClientY
                        )
                            ? viewportFocus.anchorClientY
                            : parentRect.top + parentRect.height / 2;
                        const focusedPointX =
                            contentRect.left +
                            viewportFocus.xRatio * contentRect.width;
                        const focusedPointY =
                            contentRect.top +
                            viewportFocus.yRatio * contentRect.height;

                        panState.offsetX += anchorClientX - focusedPointX;
                        panState.offsetY += anchorClientY - focusedPointY;
                    }

                    function _clampPanOffsets() {
                        if (!parentElement) {
                            return;
                        }

                        const measuredDimensions = _measureContentDimensions();
                        const panOffsetBounds =
                            _getPanOffsetBounds(measuredDimensions);

                        panState.offsetX = Math.max(
                            panOffsetBounds.minX,
                            Math.min(panOffsetBounds.maxX, panState.offsetX)
                        );
                        panState.offsetY = Math.max(
                            panOffsetBounds.minY,
                            Math.min(panOffsetBounds.maxY, panState.offsetY)
                        );
                    }

                    function _measureContentDimensions() {
                        const baseDimensions = _measureBaseContentDimensions();
                        const scale = _getScale();

                        return {
                            width: baseDimensions.width * scale,
                            height: baseDimensions.height * scale,
                        };
                    }

                    function _measureBaseContentDimensions() {
                        const svgElement = container[0].querySelector("svg");
                        const appliedScale = renderedScale || 1;

                        if (svgElement) {
                            const svgRect = svgElement.getBoundingClientRect();
                            if (svgRect.width > 0 && svgRect.height > 0) {
                                return {
                                    width: svgRect.width / appliedScale,
                                    height: svgRect.height / appliedScale,
                                };
                            }
                        }

                        return {
                            width: container[0].offsetWidth / appliedScale,
                            height: container[0].offsetHeight / appliedScale,
                        };
                    }

                    function _measureContentRect() {
                        const svgElement = container[0].querySelector("svg");

                        if (svgElement) {
                            return svgElement.getBoundingClientRect();
                        }

                        return container[0].getBoundingClientRect();
                    }

                    function _calculateCenteredOffsets(measuredDimensions) {
                        return {
                            x: Math.max(
                                (parentElement.clientWidth -
                                    measuredDimensions.width) /
                                    2,
                                0
                            ),
                            y: Math.max(
                                (parentElement.clientHeight -
                                    measuredDimensions.height) /
                                    2,
                                0
                            ),
                        };
                    }

                    function _getPanOffsetBounds(measuredDimensions) {
                        const centeredOffsets =
                            _calculateCenteredOffsets(measuredDimensions);
                        const minimumVisibleWidth =
                            Math.min(
                                measuredDimensions.width,
                                parentElement.clientWidth
                            ) *
                            (1 - MAX_PAN_OUTSIDE_RATIO);
                        const minimumVisibleHeight =
                            Math.min(
                                measuredDimensions.height,
                                parentElement.clientHeight
                            ) *
                            (1 - MAX_PAN_OUTSIDE_RATIO);

                        return {
                            minX:
                                minimumVisibleWidth -
                                measuredDimensions.width -
                                centeredOffsets.x,
                            maxX:
                                parentElement.clientWidth -
                                minimumVisibleWidth -
                                centeredOffsets.x,
                            minY:
                                minimumVisibleHeight -
                                measuredDimensions.height -
                                centeredOffsets.y,
                            maxY:
                                parentElement.clientHeight -
                                minimumVisibleHeight -
                                centeredOffsets.y,
                        };
                    }

                    function _clampRatio(value) {
                        return Math.max(0, Math.min(1, value));
                    }

                    function _getScale() {
                        return ctrl.zoom / 100;
                    }

                    function _getZoomMultiplier() {
                        return 1 + Math.max(ctrl.step, 0) / 100;
                    }

                    function _onResize() {
                        if (!ctrl.viewBox || !parentElement) {
                            return;
                        }

                        $timeout(function () {
                            const wasAtMinZoom =
                                Math.abs(ctrl.zoom - ctrl.minZoom) <=
                                ctrl.sliderStep;
                            const fitZoom = _calculateFitZoom(
                                parentElement,
                                ctrl.viewBox
                            );
                            const defaultStep = Math.max(ctrl.step, 1);
                            const minFitZoom = Math.max(
                                ctrl.sliderStep,
                                fitZoom * MIN_FIT_ZOOM_FACTOR
                            );

                            if (ctrl.maxZoom <= minFitZoom) {
                                ctrl.maxZoom = minFitZoom + defaultStep * 100;
                            }

                            ctrl.minZoom = minFitZoom;
                            if (wasAtMinZoom || ctrl.zoom < ctrl.minZoom) {
                                ctrl.zoom = ctrl.minZoom;
                                _updateZoom(ctrl.zoom, true);
                                return;
                            }

                            _clampPanOffsets();
                            _applyContainerTransform();
                            _syncPanCursor();
                        }, 0);
                    }

                    /**
                     * Increase / decrease the zoom value, by a step factor
                     */
                    function zoomIn() {
                        ctrl.zoom = Math.min(
                            ctrl.maxZoom,
                            ctrl.zoom * _getZoomMultiplier()
                        );

                        _syncPanCursor();
                    }

                    function zoomOut() {
                        ctrl.zoom = Math.max(
                            ctrl.minZoom,
                            ctrl.zoom / _getZoomMultiplier()
                        );

                        _syncPanCursor();
                    }

                    function _canPan() {
                        if (!parentElement) {
                            return false;
                        }

                        const measuredDimensions = _measureContentDimensions();

                        return (
                            measuredDimensions.width > 0 &&
                            measuredDimensions.height > 0
                        );
                    }

                    function _syncPanCursor(isPanning) {
                        if (!_canPan()) {
                            container.css("cursor", "default");
                            return;
                        }

                        container.css(
                            "cursor",
                            isPanning ? "grabbing" : "grab"
                        );
                    }

                    function _onPanStart(event) {
                        if (
                            !parentElement ||
                            event.button !== 0 ||
                            !_canPan()
                        ) {
                            return;
                        }

                        panState.isDragging = true;
                        panState.hasDragged = false;
                        panState.startClientX = event.clientX;
                        panState.startClientY = event.clientY;
                        panState.startPanOffsetX = panState.offsetX;
                        panState.startPanOffsetY = panState.offsetY;

                        _syncPanCursor(true);
                    }

                    function _onPanMove(event) {
                        if (!panState.isDragging || !parentElement) {
                            return;
                        }

                        const deltaX = event.clientX - panState.startClientX;
                        const deltaY = event.clientY - panState.startClientY;

                        if (
                            !panState.hasDragged &&
                            Math.abs(deltaX) < 2 &&
                            Math.abs(deltaY) < 2
                        ) {
                            return;
                        }

                        panState.hasDragged = true;
                        event.preventDefault();

                        panState.offsetX = panState.startPanOffsetX + deltaX;
                        panState.offsetY = panState.startPanOffsetY + deltaY;

                        _clampPanOffsets();
                        _applyContainerTransform();
                    }

                    function _onPanEnd() {
                        if (!panState.isDragging) {
                            return;
                        }

                        if (panState.hasDragged) {
                            panState.suppressClick = true;
                        }

                        panState.isDragging = false;
                        panState.hasDragged = false;
                        _syncPanCursor(false);
                    }
                },
            };
        }
    );
